import { logInfo } from '@lune/common/logger'
import { cacheBustReload } from '@lune/common/updates'
import { ThemeProvider as MyThemeProvider } from '@lune/theme/context'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const container = document.getElementById('root')
if (container === null) {
  throw new Error("Can't create application container")
}
const root = createRoot(container)

if (process.env.NODE_ENV === 'development') {
  logInfo('Adding /esbuild event source')
  new EventSource('/esbuild').addEventListener('change', () => {
    logInfo('Hot reloading app')
    cacheBustReload()
  })
}

root.render(
  <React.StrictMode>
    <MyThemeProvider>
      <App />
    </MyThemeProvider>
  </React.StrictMode>
)
